import React from "react";
import "./Privacypolicy.css";

const styles = {
  body: {
    backgroundColor: "#121212",
    color: "#e0e0e0",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    margin: 0,
    padding: 0,
    paddingTop: "100px",
    minHeight: "100vh",
  },
  header: {
    backgroundColor: "#1f1f1f",
    padding: "16px 20px",
    textAlign: "center",
    borderBottom: "1px solid #333",
  },
  headerTitle: {
    margin: 0,
    fontSize: "1.5em",
    color: "#17BD3B",
  },
  container: {
    maxWidth: "900px",
    margin: "20px auto",
    padding: "0 16px",
  },
  section: {
    marginBottom: "30px",
  },
  sectionTitle: {
    fontSize: "1.2em",
    borderBottom: "1px solid #333",
    paddingBottom: "8px",
    marginBottom: "16px",
    color: "#17BD3B",
  },
  subsectionTitle: {
    fontSize: "1.1em",
    margin: "16px 0 8px",
    color: "#17BD3B",
  },
  point: {
    marginBottom: "10px",
    lineHeight: 1.6,
    fontSize: "14px",
  },
  strong: {
    color: "#17BD3B",
  },
  // footer: {
  //   textAlign: "center",
  //   padding: "20px",
  //   backgroundColor: "#1f1f1f",
  //   borderTop: "1px solid #333",
  //   color: "#777",
  //   fontSize: "0.9em",
  // },
};

const Privacypolicy = () => {
  return (
    <div style={styles.body}>
      <header style={styles.header}>
        <h1 style={styles.headerTitle}>Fusshn Privacy Policy</h1>
      </header>

      <div style={styles.container}>
        {/* Section 1 */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Introduction</h2>
          <div style={styles.point}>
            Fusshn (“we,” “us,” or “our”) operates as a platform that connects
            users with event organizers for purchasing and selling event
            tickets. Protecting your privacy is central to our operations.
          </div>
          <div style={styles.point}>
            This Privacy Policy applies to information collected through our
            app, website, and related services. It does not cover third-party
            websites, services, or applications that you may access through
            Fusshn.
          </div>
        </section>

        {/* Section 2 */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>2. Information We Collect</h2>

          <div>
            <h3 style={styles.subsectionTitle}>Personal Information</h3>
            <div style={styles.point}>
              <strong style={styles.strong}>Account Registration:</strong> When
              creating an account, we may ask for personal details, including
              your name, email address, and phone number.
            </div>
            <div style={styles.point}>
              <strong style={styles.strong}>Payment Information:</strong> When
              purchasing tickets, we collect billing information (such as
              payment card details), which are securely processed through our
              payment partners.
            </div>
            <div style={styles.point}>
              <strong style={styles.strong}>Contact Information:</strong> We may
              also collect your email address, phone number, or social media
              profile if provided during sign-up or when subscribing to
              newsletters.
            </div>
          </div>

          <div>
            <h3 style={styles.subsectionTitle}>Location Data</h3>
            <div style={styles.point}>
              <strong style={styles.strong}>Location-Based Services:</strong>{" "}
              With your permission, we may collect real-time location data to
              provide recommendations on events near you and to tailor the event
              listings based on your location.
            </div>
          </div>

          <div>
            <h3 style={styles.subsectionTitle}>Usage Data</h3>
            <div style={styles.point}>
              <strong style={styles.strong}>App Interactions:</strong> We
              collect information on how you interact with the Fusshn app,
              including pages visited, time spent, features accessed, and links
              clicked.
            </div>
            <div style={styles.point}>
              <strong style={styles.strong}>Event Preferences:</strong> We may
              collect information about events you're interested in, attend, or
              purchase, to personalize recommendations.
            </div>
          </div>

          <div>
            <h3 style={styles.subsectionTitle}>Device Information</h3>
            <div style={styles.point}>
              We collect technical information about the device you're using,
              including device type, operating system, IP address, unique device
              identifiers, and crash reports to enhance app functionality and
              compatibility.
            </div>
          </div>
        </section>

        {/* Section 3 */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>3. How We Use Your Information</h2>

          <div>
            <h3 style={styles.subsectionTitle}>
              Service Provision and Improvement
            </h3>
            <div style={styles.point}>
              <strong style={styles.strong}>Account Management:</strong> Your
              personal information is used to manage and personalize your Fusshn
              account and provide seamless access to our platform.
            </div>
            <div style={styles.point}>
              <strong style={styles.strong}>Order Processing:</strong> We use
              your information to complete ticket purchases, process
              transactions, and communicate order details.
            </div>
            <div style={styles.point}>
              <strong style={styles.strong}>
                Personalized Recommendations:
              </strong>{" "}
              Based on your preferences and activity, we provide tailored
              recommendations to improve your experience.
            </div>
          </div>

          <div>
            <h3 style={styles.subsectionTitle}>Marketing and Communication</h3>
            <div style={styles.point}>
              <strong style={styles.strong}>Notifications:</strong> We send
              reminders about upcoming events, promotional offers, and platform
              updates, which can be managed through notification settings.
            </div>
            <div style={styles.point}>
              <strong style={styles.strong}>Surveys and Feedback:</strong> We
              may reach out for feedback to improve our services and collect
              opinions on user experience.
            </div>
          </div>

          <div>
            <h3 style={styles.subsectionTitle}>
              Security and Fraud Prevention
            </h3>
            <div style={styles.point}>
              <strong style={styles.strong}>Verification:</strong> Information
              may be used to verify your identity to prevent fraud, abuse, or
              other unauthorized activities.
            </div>
            <div style={styles.point}>
              <strong style={styles.strong}>Monitoring:</strong> We may analyze
              usage patterns to identify security risks and ensure the integrity
              of our services.
            </div>
          </div>
        </section>

        {/* Sections 4 to 11 */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>4. How We Share Your Information</h2>
          <div style={styles.point}>
            We may share your information with event organisers, service
            providers, for legal compliance, or in business transfers as
            necessary.
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Security Measures</h2>
          <div style={styles.point}>
            We prioritize the security of your information and have implemented
            measures such as encryption, secure servers, and access control.
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Your Rights and Choices</h2>
          <div style={styles.point}>
            <strong style={styles.strong}>Access:</strong> You have the right to
            access the personal data we hold about you.
          </div>
          <div style={styles.point}>
            <strong style={styles.strong}>Update:</strong> You can update your
            personal information via account settings.
          </div>
          <div style={styles.point}>
            <strong style={styles.strong}>Delete:</strong> You can delete your
            account, though some data may be retained.
          </div>
          <div style={styles.point}>
            <strong style={styles.strong}>Opt-Out:</strong> You can opt-out of
            promotional communications through settings or unsubscribe links.
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            7. Cookies and Tracking Technologies
          </h2>
          <div style={styles.point}>
            We use cookies and tracking technologies for a better experience.
            You can manage these via browser settings.
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Third-Party Links and Services</h2>
          <div style={styles.point}>
            We are not responsible for the privacy practices of third-party
            websites or services linked from Fusshn.
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>9. Children's Privacy</h2>
          <div style={styles.point}>
            Fusshn is not intended for children under 13. We do not knowingly
            collect data from children.
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            10. Changes to This Privacy Policy
          </h2>
          <div style={styles.point}>
            We may update this policy and will notify users of significant
            changes.
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>11. Contact Us</h2>
          <div style={styles.point}>
            <strong style={styles.strong}>Email:</strong> fusshn.business@gmail.com
          </div>
          {/* <div style={styles.point}>
            <strong style={styles.strong}>Address:</strong> Garudacharpalya,
            Bengaluru, Karnataka, 560048
          </div> */}
        </section>
      </div>
    </div>
  );
};

export default Privacypolicy;
